import { useQuery } from '@tanstack/react-query'

import { useCurrentUser } from '@/api/auth/queries/useCurrentUser'
import { QUERY_KEYS } from '@/lib/queryKeys'

import { getAffiliateUserData } from '../affiliateService'

export const useAffiliateUserData = () => {
  const { data: currentUser } = useCurrentUser()
  const refNum = currentUser?.UserAttributes?.['custom:refNum']
  return useQuery({
    queryKey: [QUERY_KEYS.AFFILIATE],
    queryFn: () => getAffiliateUserData(),
    enabled: !!refNum,
  })
}
